module.exports = __webpack_public_path__ + "static/img/step4.41f978d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pages/task/step4.png
// module id = 18nv
// module chunks = 30